import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  GetAccessLogsInputDto,
  GetAccessLogsOutputDto,
} from '../../../models/access-control/dto/get-access-logs.dto';

export const GET_ACCESS_LOGS_QUERY_KEY = (
  organizationId: string,
  params: Omit<GetAccessLogsInputDto, 'page' | 'limit'>,
  page: number,
  limit: number,
) => [organizationId, 'access-logs', params, page, limit];

export const useGetAccessLogs = (
  organizationId: string | undefined,
  params: GetAccessLogsInputDto,
) => {
  const client = useApiClient();

  const page = params.page ?? 0;
  const limit = params.limit ?? 20;
  const { doorId, userId, eventType, dateFrom, dateTo } = params;

  return useQuery({
    queryKey: GET_ACCESS_LOGS_QUERY_KEY(
      organizationId || '',
      { doorId, userId, eventType, dateFrom, dateTo },
      page,
      limit,
    ),
    enabled: !!organizationId,
    queryFn: () => {
      const queryParams = new URLSearchParams();
      queryParams.append('page', page.toString());
      queryParams.append('limit', limit.toString());
      if (doorId) queryParams.append('doorId', doorId);
      if (userId) queryParams.append('userId', userId);
      if (eventType) queryParams.append('eventType', eventType);
      if (dateFrom) queryParams.append('dateFrom', dateFrom);
      if (dateTo) queryParams.append('dateTo', dateTo);

      return client.fetchApi<GetAccessLogsOutputDto, {}>({
        endpoint: `access-control/admin/logs/${organizationId}?${queryParams.toString()}`,
        method: 'GET',
      });
    },
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
    keepPreviousData: true,
  });
};
